import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../Univ";
import { useLocation, useNavigate } from "react-router-dom";

function Checkout() {

  const location = useLocation();
  const navigate = useNavigate();

  // From Cart
  const total = location.state?.total || 0;
  const cartItems = location.state?.items || [];

  const [paymentMethod, setPaymentMethod] = useState("ONLINE");
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");

  // ---------------------------
  // FETCH ADDRESS
  // ---------------------------
  useEffect(() => {
    fetchAddress();
  }, []);

  const fetchAddress = async () => {
    const userId = localStorage.getItem("user_id");
    if (!userId) return;

    const res = await axios.get(`${baseUrl}profile/?user_id=${userId}`);
    setAddress(res.data.address || "");
  };

  // ---------------------------
  // LOAD RAZORPAY
  // ---------------------------
  const loadScript = (src) => {
    return new Promise(resolve => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // ---------------------------
  // ONLINE PAYMENT
  // ---------------------------
  const handleOnlinePayment = async () => {

    setLoading(true);

    const loaded = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!loaded) {
      alert("Razorpay SDK Failed");
      return;
    }

    // Create backend order
    const res = await axios.post(
      baseUrl + "create-order/",
      {
        amount: total,
        items: cartItems
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`
        }
      }
    );

    const options = {
      key: "rzp_live_SFZl3kO1drrhJz",
      amount: res.data.amount,
      currency: "INR",
      name: "My Shop",
      description: "Order Payment",
      order_id: res.data.razorpay_order_id,

      handler: async function (response) {

        await axios.post(
          baseUrl + "verify-payment/",
          {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access")}`
            }
          }
        );

        navigate("/orders");
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

    setLoading(false);
  };

  // ---------------------------
  // CASH ON DELIVERY
  // ---------------------------
  const handleCOD = async () => {

    const res = await axios.post(
  baseUrl + "cod-order/",
  {},
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`
    }
  }
);


    navigate(`/`);
  };

  // ---------------------------
  // PLACE ORDER
  // ---------------------------
  const handlePlaceOrder = () => {
    paymentMethod === "ONLINE"
      ? handleOnlinePayment()
      : handleCOD();
  };

  return (
    <div className="container mt-4">

      <div className="row">

        <div className="col-md-8">

          <div className="card mb-3">
            <div className="card-body">
              <h5>Shipping Address</h5>
              <textarea
                className="form-control"
                rows="3"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>

          <div className="card">
            <div className="card-body">

              <h5>Payment Method</h5>

              <div className="form-check">
                <input
                  type="radio"
                  checked={paymentMethod === "ONLINE"}
                  onChange={() => setPaymentMethod("ONLINE")}
                />
                Online Payment
              </div>

              <div className="form-check mt-2">
                <input
                  type="radio"
                  checked={paymentMethod === "COD"}
                  onChange={() => setPaymentMethod("COD")}
                />
                Cash On Delivery
              </div>

            </div>
          </div>

        </div>

        <div className="col-md-4">

          <div className="card">
            <div className="card-body">

              <h5>Order Summary</h5>
              <h4>₹{total}</h4>

              <button
                className="btn btn-success w-100 mt-3"
                disabled={loading}
                onClick={handlePlaceOrder}
              >
                {loading ? "Processing..." : "Place Order"}
              </button>

            </div>
          </div>

        </div>

      </div>

    </div>
  );
}

export default Checkout;
